/*
 * @Author: Tina Huang
 * @Date: 2024-02-18 17:27:07
 * @LastEditors: Tina Huang
 * @LastEditTime: 2025-02-08 15:49:40
 * @Description:
 */
import { useState, useMemo, useRef } from 'react'
import { times, effes, others } from '@/constants/libs'
import type { TourProps } from 'antd'
import { Flex, Radio, Tour, Select } from 'antd'
import LibItem from './components/Items'

export default function Libs() {
  const isMobile = window.innerWidth <= 750
  const [type, setType] = useState<any>('times')
  const [open, setOpen] = useState<boolean>(false)
  const w_ref = useRef(null)

  const handleChange = (e: any) => {
    if (typeof e === 'string') return setType(e)
    const _type = e?.target?.value
    setType(_type)
  }

  const steps: TourProps['steps'] = [{ title: '选择想要的组件', description: '进入组件配置', target: () => w_ref.current! }]

  const libsList = useMemo(() => {
    if (type === 'times') return times.filter((item) => !item.close)
    else if (type === 'effes') return effes.filter((item) => !item.close)
    else if (type === 'tools') return others.filter((item) => !item.close)
    return []
  }, [type])

  const lists = useMemo(() => {
    if (isMobile) return [libsList]
    const _l1 = libsList.filter((item) => item.id % 4 === 3)
    const _l2 = libsList.filter((item) => item.id % 4 === 2)
    const _l3 = libsList.filter((item) => item.id % 4 === 1)
    const _l4 = libsList.filter((item) => item.id % 4 === 0)
    return [_l1, _l2, _l3, _l4]
  }, [libsList, isMobile])

  // const handleTour = () => {
  //   setOpen(true)
  // }

  const options = [
    { value: 'times', label: '🕛 时间组件' },
    { value: 'effes', label: '💪 效率组件' },
    { value: 'tools', label: '🔧 其他组件' },
    { value: 'formulas', label: '🟰 Notion公式', disabled: true },
  ]

  return (
    <>
      <Flex gap="middle" justify="center">
        {isMobile && <Select defaultValue={type} onChange={handleChange} options={options} className="w-full" />}
        {!isMobile && (
          <Radio.Group onChange={handleChange} defaultValue={type} size="large" buttonStyle="solid">
            {options.map((item) => (
              <Radio.Button key={item.value} value={item.value} disabled={item.disabled}>
                {item.label}
              </Radio.Button>
            ))}
            {/* <Button type="link" className="text-blue-500" onClick={handleTour}>
            如何使用？
          </Button> */}
          </Radio.Group>
        )}
      </Flex>
      <div className={`pt-12 flex ${isMobile ? 'justify-center' : 'justify-between'}`}>
        {lists.map((list, index) => (
          <div>
            {list.map((item) => (
              <LibItem item={item} key={item.id} />
            ))}
          </div>
        ))}
      </div>
      <Tour open={open} onClose={() => setOpen(false)} steps={steps} />
    </>
  )
}
